(function () {
  if (typeof document === 'undefined') return;
  function init(section) {
    const track = section.querySelector('[data-carousel-track]');
    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    if (!track) return;
    const step = () => {
      const first = track.firstElementChild;
      if (!first) return 320;
      const cs = window.getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap || 18);
      return first.getBoundingClientRect().width + gap;
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
      if (next) next.toggleAttribute('disabled', track.scrollLeft >= max);
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initAll() { document.querySelectorAll('[data-carousel]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();